module.exports = __webpack_public_path__ + "static/media/undraw_product_explainer.a3c04744.svg";